(function() {
    let tlDiscountCodeClone;
    
    Object.defineProperty(window, "tlDiscountCode", {
        get() {
            return tlDiscountCodeClone;
        },
        set(val) {
            if (val && !tlDiscountCodeClone) {
                tlDiscountCodeClone = val;
                val.handleClickApplyButtonElement = async (codeValue) => {
                    const errorEl = document.querySelector('.tl-discount-code-error');

                    const ruleHasCodeArr = window.tlDiscountCode.codeMapRuleId.get(codeValue) || [];

                    const ruleIdAppliedppliedSet = new Set(window.tlDiscountCode.ruleIdApplied || []);
                    const isCodeAlreadyApplied = window.tlDiscountCode.discountCodeApplied.includes(codeValue);
                    if (isCodeAlreadyApplied) {
                        errorEl.innerText = 'Code already applied';
                        return;
                    }

                    if(window.tlDiscountCode.discountCodeApplied.length >= 5) {
                        errorEl.innerText = 'Maximum 5 discount codes allowed';
                        return;
                    }

                    // filter all rule has codeVale
                    const autoAddRuleIdArr = [];
                    const manualAddRuleIdArr = [];
                    for(let i = 0; i < ruleHasCodeArr.length; i++) {
                        const ruleId = ruleHasCodeArr[i];
                        const rule = window.tlDiscountCode.ruleIdMapData.get(ruleId);
                        if (!rule) continue;

                        if (rule.gift_add_type !== DiscountCodeConstant.GIFT_ADD_TYPE.MANUAL) {
                            if (!autoAddRuleIdArr.includes(ruleId)) {
                                autoAddRuleIdArr.push(ruleId);
                            }
                        } else {
                            if (isCodeAlreadyApplied) continue;

                            if (!manualAddRuleIdArr.includes(ruleId) && !ruleIdAppliedppliedSet.has(ruleId)) {
                                manualAddRuleIdArr.push(ruleId);
                            }
                        }
                        
                    }
                    
                    if(!isCodeAlreadyApplied) {
                        const isApplyDiscountCode = await DiscountCodeAjaxApi.applyDiscounts([codeValue]);
                        if (!isApplyDiscountCode) {
                            errorEl.innerText = 'Unable to apply code';
                            return;
                        } else {
                            if(!autoAddRuleIdArr.length) {
                                const currentDiscountCodeApplied = window.tlDiscountCode.discountCodeApplied || [];
                                if(!currentDiscountCodeApplied.includes(codeValue)) {
                                    currentDiscountCodeApplied.push(codeValue);
                                }
                                window.tlDiscountCode.discountCodeApplied = currentDiscountCodeApplied;
                                window.tlDiscountCode.renderCodeApplied();
                                await window.tlDiscountCode.refreshCart();
                            } else {
                                for(let i = 0; i < autoAddRuleIdArr.length; i++) {
                                    const autoAddRuleId = autoAddRuleIdArr[i];
                                    const currentQtyCodeApplied = window.tlDiscountCode.ruleIdMapNumberCodeApplied.get(autoAddRuleId) || 0;
                                    window.tlDiscountCode.ruleIdMapNumberCodeApplied.set(autoAddRuleId, currentQtyCodeApplied + 1);
                                }
                            }
                        }
                    }
            
                    errorEl.innerText = '';
                    if(autoAddRuleIdArr.length) {
                        const autoAddGiftReq = await window.tlDiscountCode.handleAutoAddGift(autoAddRuleIdArr);
                        if(autoAddGiftReq.status == 200) {
                            await window.tlDiscountCode.refreshCart();
                            await window.tlDiscountCode.getGiftAdded();
                            window.tlDiscountCode.renderCodeApplied();
                        }

                    }

                    if(manualAddRuleIdArr.length) {
                        window.tlDiscountCode.renderGiftSelector(manualAddRuleIdArr, autoAddRuleIdArr.length === 0);
                    }
                    const codeBoxElement = document.querySelector(".tl-discount-code-box");
                    if(codeBoxElement) {
                        codeBoxElement.value = "";
                    }

                }
            }
        },
        configurable: true
    });
})();